var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6431 22.9141C17.7182 22.9141 22.6431 17.9892 22.6431 11.9141C22.6431 5.83893 17.7182 0.914062 11.6431 0.914062C5.56793 0.914062 0.643066 5.83893 0.643066 11.9141C0.643066 17.9892 5.56793 22.9141 11.6431 22.9141Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 3.66406V9.76219L17.1395 12.0653L11.9854 3.66406Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 3.66406L6.83057 12.0653L11.9854 9.76219V3.66406Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 16.0169V20.1605L17.143 13.0249L11.9854 16.0169Z",
    fill: "white",
    fillOpacity: 0.602
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 20.1605V16.0162L6.83057 13.0249L11.9854 20.1605Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9854 15.0581L17.1395 12.0654L11.9854 9.76367V15.0581Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83057 12.0654L11.9854 15.0581V9.76367L6.83057 12.0654Z",
    fill: "white",
    fillOpacity: 0.602
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.b98d5dae3a3c59b9f1387f4773c09296.svg";
export { ForwardRef as ReactComponent };